import React from "react";
import { motion } from "framer-motion";
import {
  HiOutlineDocumentText,
  HiOutlineCalendar,
  HiOutlineUserCircle,
  HiOutlineShare,
} from "react-icons/hi2";
import { useLanguage } from "../../../contexts/LanguageContext";
import SectionHeading from "../SectionHeading";

const SERVICES = [
  {
    icon: HiOutlineDocumentText,
    labelKey: "serviceRecipesOnline",
    descKey: "serviceRecipesDesc",
  },
  {
    icon: HiOutlineCalendar,
    labelKey: "serviceMealIdeas",
    descKey: "serviceMealDesc",
  },
  {
    icon: HiOutlineUserCircle,
    labelKey: "serviceMemberAccount",
    descKey: "serviceMemberDesc",
  },
  {
    icon: HiOutlineShare,
    labelKey: "serviceShareRecipes",
    descKey: "serviceShareDesc",
  },
];

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
  },
};

/**
 * Grille numérotée (01–04), en écho au motif de rang de la section
 * « Top recettes » : un fil visuel cohérent plutôt que 4 cartes icône
 * identiques et interchangeables.
 */
const ServicesSection = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="py-12 sm:py-16 md:py-20 lg:py-24 w-full min-w-0 scroll-mt-20">
      <SectionHeading
        index="05"
        kicker={t("servicesSubtitle")}
        title={t("ourServices")}
        description={t("servicesIntro")}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 border-t border-ink-900/10">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.article
              key={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={itemVariants}
              transition={{ delay: (i % 2) * 0.08 }}
              className={`group relative py-8 sm:py-10 px-1 sm:px-8 border-b border-ink-900/10 ${
                i % 2 === 0 ? "md:border-r md:pr-8" : "md:pl-8"
              }`}
            >
              <div className="flex items-start gap-5">
                <span className="font-poster text-2xl font-bold text-ink-900/20 shrink-0 pt-0.5">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-3">
                    <Icon className="w-5 h-5 text-ember-600 shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5" />
                    <h3 className="font-semibold text-ink-900 text-lg">
                      {t(s.labelKey)}
                    </h3>
                  </div>
                  <p className="text-ink-500 text-sm sm:text-base leading-relaxed">
                    {t(s.descKey)}
                  </p>
                </div>
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesSection;
